import React from 'react';
import { ITask } from '../Interfaces/ITask';
import { Chip } from '@mui/material';
import { ITaskPriority } from '../Interfaces/ITaskPriority';

interface IProps {
  task: ITask;
  taskPriorities?: ITaskPriority[];
}

export const getPriorityColor = (task: ITask) => {
  if (task.idTaskPriority === 1) return 'grey.500';
  if (task.idTaskPriority === 2) return 'success.main';
  if (task.idTaskPriority === 3) return 'warning.main';
  return 'error.main';
};

export const TaskPriorityChip: React.FC<IProps> = ({
  task,
  taskPriorities,
}) => {
  const currentPriority = taskPriorities?.find(
    taskPrio => taskPrio.idTaskPriority === task.idTaskPriority
  );

  return (
    <Chip
      size='small'
      label={currentPriority ? currentPriority.TaskPriority : task.TaskPriority}
      sx={{
        bgcolor: getPriorityColor(task),
        color: '#fff',
      }}
    />
  );
};
